import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=f655c0dc&scoped=true&"
import script from "./ratings.vue?vue&type=script&lang=js&"
export * from "./ratings.vue?vue&type=script&lang=js&"
import style0 from "./ratings.vue?vue&type=style&index=0&id=f655c0dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f655c0dc",
  null
  
)

export default component.exports